<template>
  <div class="wrap">
    <Header :userInfo="userInfo"/>
    <div class="bannerWrap">
      <Carousel @onLogin="onLogin"></Carousel>
    </div>
<!--    <div class="address">-->
<!--      <div class="addressMain">-->
<!--        <el-row type="flex" justify="space-between" class="">-->
<!--          <el-col-->
<!--              :class="$i18n.locale==='zh'?'el-col':'el-col2'"-->
<!--              @click.native="addressClick(index)"-->
<!--              v-for="(item, index) in addressInfo"-->
<!--              :key="index"-->
<!--              :span="index === 0? 7: index === 1? 9: index === 2? 6: ''"-->
<!--          >-->
<!--            <div class="left bgCommon" :style="{backgroundImage: 'url(' + item.img + ')'}"></div>-->
<!--            <div class="addressTitle" v-html="item.title"/>-->
<!--            <div class="addressText" v-if="$i18n.locale=='zh'">-->
<!--              <p v-html="item.info" v-if="index !== 0"></p>-->
<!--              <p v-else>-->
<!--                使用可信时间戳证据的裁判文书{{ accountNum.precedentTotal }}件-->
<!--              </p>-->
<!--            </div>-->
<!--            <div class="addressBot" v-if="index === 0 && $i18n.locale==='zh'">-->
<!--              (数据来源：中国裁判文书网)-->
<!--            </div>-->
<!--          </el-col>-->
<!--        </el-row>-->
<!--      </div>-->
<!--    </div>-->
    <div class="iprWork">
      <div class="workMain">
        <div class="workTitle" v-html="iprWorkInfo.title"></div>
        <div class="workList">
          <el-row type="flex" justify="space-between" class="aCol">
            <el-col class="left" :span="8">
              <div
                  v-for="(item, index) in iprWorkInfo.listInfo"
                  :key="index"
                  @click="workClick(item, index)"
                  :class="(workActive === index)? ($i18n.locale==='zh'?'workListLeft workLeftActive' :'workLeftEnActive workListLeft'):'workListLeft'"
                  @mouseover="mouseOver()"
                  @mouseleave="mouseLeave()"
              >
                <div class="leftTitle" v-html="item.leftTitle" :class="{leftTitleActive: workActive === index}">
                </div>
                <div
                    class="leftInfo"
                    v-html="item.leftInfo"
                    :class="{baseBreak:workActive !== index? 'baseBreak': '',}"
                ></div>
                <div
                    class="leftImg bgCommon"
                    :style="{backgroundImage:'url(' + item.leftImg + ')'}"
                    v-if="workActive === index"
                ></div>
                <el-progress
                    :percentage="percentage"
                    color="#3F7DF7"
                    class="line"
                    v-if="workActive === index"
                ></el-progress>
              </div>
            </el-col>
            <el-col :span="16">
              <div
                  class="workListRight"
                  v-for="(item, index) in iprWorkInfo.listInfo"
                  :key="index"
                  :class="{workRightActive: workActive === index,}"
                  @mouseover="mouseOver()"
                  @mouseleave="mouseLeave()"
              >

                <div v-if="workActive === index">
                  <div class="rightTitle" v-html="item.rightTitle"></div>
                  <div class="rightListMain">
                    <div class="rightListTitle">
                      {{ item.rightList1.title || "" }}
                    </div>
                    <div class="rightList1" v-for="(item2) in item.rightList1.list" :key="item2">
                      {{ item2 }}
                    </div>
                    <p>......</p>
                    <div class="col" v-if="workActive === 2"></div>
                    <div class="rightTitle rightTitleN" v-html="item.rightTitle2" v-if="item.rightTitle2"></div>
                    <div class=" rightListTitle rightListTitle2" v-if="item.rightList2">
                      {{ item.rightList2.title || "" }}
                    </div>
                    <div v-if="item.rightList2" style="width: 90%">
                      <div class="rightList1" v-for="(item2) in item.rightList2.list" :key="item2">
                        {{ item2 }}
                      </div>
                      <p>......</p>
                    </div>
                    <div class="workBtn" @click="onLogin">
                      {{ item.btnInfo }}
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <div class="workLogo bgCommon" :style="{backgroundImage:'url(' + iprWorkInfo.workLogo + ')'}"
               @mouseover="mouseOver()" @mouseleave="mouseLeave()">
          </div>
        </div>
      </div>
    </div>
    <div class="solution bgCommon"
         :style="{backgroundImage:'url(' +solutionInfo.solutionList[solutionActive].solutionIcon +')',}"
    >
      <div class="solutionBC"></div>
      <div class="solutionMain">
        <div class="solutionTitle">{{ $t('solutionInfo.title') }}</div>
        <div class="solutionNav">
          <p
              @click="prevBtn"
              class="bgCommon leftIcon"
              :style="{backgroundImage:'url(' + solutionInfo.leftIcon + ')'}"
              v-if="solutionActive !== 0"
          />
          <div class="navScroll">
            <swiper :options="swiperOption" ref="solutionSwiper" class="swiperInfo">
              <swiper-slide class="navText" v-for="(item, index) in solutionInfo.solutionList" :key="index">
                <p :class="{solutionActive:solutionActive === index}" @click="solutionClick(item, index)">
                  {{ item.title }}
                </p>
              </swiper-slide>
            </swiper>
          </div>
          <p
              @click="nextBtn"
              class="bgCommon rightIcon"
              :style="{backgroundImage:'url(' + solutionInfo.rightIcon + ')',}"
              v-if="solutionActive !==solutionInfo.solutionList.length - 1"
          />
        </div>
        <div class="solutionInfo">
          <div
              class="infoText"
              v-for="(item2, index2) in solutionInfo.solutionList[solutionActive].infoTitleList"
              :key="index2"
              :class="{solutionActive: solutionActive === index2}"
          >
            <p>{{ item2 }}</p>
            <span v-if="index2 <solutionInfo.solutionList[solutionActive].infoTitleList.length -1">|</span>
          </div>
          <div class="infoMain infoMain1" v-html="solutionInfo.solutionList[solutionActive].infoMain"></div>
          <div class="infoMain" v-html="solutionInfo.solutionList[solutionActive].infoMain1"></div>
          <div class="infoMain" v-html="solutionInfo.solutionList[solutionActive].infoMain2"></div>
          <div class="infoMain" v-html="solutionInfo.solutionList[solutionActive].infoMain3"></div>
          <div class="infoMain" v-html="solutionInfo.solutionList[solutionActive].infoMain4"></div>
          <!--          <div class="infoBtn" @click="dockModal=true">{{ $t('solutionInfo.infoBtn') }}</div>-->
        </div>
      </div>
    </div>
    <div class="principle">
      <div class="principleTitle" v-html="$t('principleTitle')"></div>
      <div class="principleVideo">
        <div class="videoBtn">

        </div>
      </div>
      <div class="principleImg">
        <img src="@/assets/images/newIndex/principleImgEN.png" alt="" v-if="$i18n.locale==='en'">
        <img src="@/assets/images/newIndex/principleImgCN.png" alt="" v-else>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import {channelLink} from "@/config/channel.js";
import {
  questionAnswer,
  precedent,
  precedentStatistics,
  precedentSearchByCondition,
  getCurrentTime
} from "@/api/tsaService";
import {me} from "@/api/service";
import {unreadCount} from "@/api/accountService";
import {swiper, swiperSlide} from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
import qs from "qs";
import Carousel from './carousel.vue'
import {hrefOpen} from '@/utils/filter'
import Header from "@/components/Header";
import Footer from '@/components/Footer'

let timer;
export default {
  metaInfo: {
    title: "知识产权保护平台-司法认可的商业秘密和知识产权及原创证明平台",
    meta: [
      {
        name: "keyWords",
        content:
            "知识产权保护,知识产权保护平台",
      },
      {
        name: "description",
        content:
            "知识产权保护平台为数据、文件、创作提供知识产权存证服务，包含商业秘密保护、著作权保护、版权保护、商标保护、专利保护、数据知识产权存证等内容，证据权属清晰、司法认可。",
      },
    ],
  },
  data() {
    return {
      currentTime: null,
      videoUrl: channelLink(
          process.env.VUE_APP_TSA + "/guide/detail/1040",
          "bdipr"
      ),
      bannerbg: {
        backgroundImage:
            "url(" + require("@/assets/images/newHome/banner.png") + ")",
        backgroundRepeat: "no-repeat",
      },
      active: 0,
      courtRank: [
        {
          id: 1001549,
          name: "商业秘密",
          type: "precedent_usage",
        },
        {
          id: 970753,
          name: "商标",
          type: "precedent_column",
        },
        {
          id: 971777,
          name: "专利",
          type: "precedent_column",
        },
        {
          id: 972801,
          name: "著作权",
          type: "precedent_column",
        },
        {
          id: 1001548,
          name: "数字资产",
          type: "precedent_usage",
        },
      ],
      conditionList: [],
      questionsList: [],
      keywords: "",
      tabactive: 1001549,
      swiperOptions: {
        notNextTick: true,
        //循环
        loop: false,
        loopAdditionalSlides: 0,
        //设定初始化时slide的索引
        initialSlide: 0,
        //自动播放
        autoplay: {
          delay: 4000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        //滑动速度
        speed: 1500,
        //滑动方向
        direction: "horizontal",
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        //小手掌抓取滑动
        // grabCursor : true,
      },

      logosList: [
        {
          img: require("@/assets/images/partner/1.png"),
        },
        {
          img: require("@/assets/images/partner/2.png"),
        },
        {
          img: require("@/assets/images/partner/3.png"),
        },
        {
          img: require("@/assets/images/partner/4.png"),
        },
        {
          img: require("@/assets/images/partner/5.png"),
        },
        {
          img: require("@/assets/images/partner/6.png"),
        },
        {
          img: require("@/assets/images/partner/7.png"),
        },
        {
          img: require("@/assets/images/partner/8.png"),
        },
        {
          img: require("@/assets/images/partner/9.png"),
        },
        {
          img: require("@/assets/images/partner/10.png"),
        },
        {
          img: require("@/assets/images/partner/11.png"),
        },
        {
          img: require("@/assets/images/partner/12.png"),
        },
      ],
      zheShow: false,
      accountNum: {},
      userInfo: {},
      verifyUi: {
        url: process.env.VUE_APP_VERIFY,
        target: "_blank",
      },

      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [],
        poster: "", // 封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true, // 是否显示全屏按钮
        },
      },
      shareActive: false,
      videoPath: "",
      videoTSAPath:
          "https://evidence-public.oss-cn-beijing.aliyuncs.com/content/banner/40cde858e2ec420cb0115d29d378ac0c/%E7%9F%A5%E8%AF%86%E4%BA%A7%E6%9D%83%E5%B9%B3%E5%8F%B0%E6%93%8D%E4%BD%9C%E6%8C%87%E5%BC%95.mp4",
      qrcode: "",
      isShowVideo: false,
      workActive: -1,
      solutionActive: 0,
      percentage: 0,
      swiperOption: {
        slidesPerView: 6,
        spaceBetween: 0,
        notNextTick: true,
        loop: false,
        autoplay: 3000,
        direction: "horizontal",
        grabCursor: true,
        setWrapperSize: true,
        autoHeight: true,
        pagination: ".swiper-pagination",
        paginationClickable: true,
        navigation: {
          prevEl: ".swiper-button-prev", //上一张
          nextEl: ".swiper-button-next", //下一张
        },
        scrollbar: ".swiper-scrollbar", //滚动条
        mousewheelControl: true,
        observeParents: true,
        hideOnClick: true,
      },
      dockModal: false,
      messageInfo: {}
    };
  },

  components: {
    swiper,
    swiperSlide,
    Carousel,
    Header,
    Footer
  },
  watch: {
    workActive(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.percentage = 0;
      }
    },
    percentage(newVal, oldVal) {
      if (newVal === 100) {
        setTimeout(() => {
          if (this.workActive == this.iprWorkInfo.listInfo.length - 1) {
            this.workActive = 0;
          } else {
            this.workActive = this.workActive + 1;
          }
        }, 500)
      }
    },
  },
  computed: {

    navContent() {
      return {
        topNavBar: [
          {
            name: this.$t('header.nav.aboutUs'),
            link: process.env.VUE_APP_TSAPLUS + '/about.html',
            target: '_blank',
          },
        ],
        bigNavBar: [
          {
            name: this.$t('header.nav.home'),
            link: process.env.VUE_APP_TSAPLUS,
            target: '_self',
          },
          {
            name: this.$t('header.newNav.qlws'),
            link: process.env.VUE_APP_TSAPLUS + '/quanliweishi.html',
            target: '_self',
          },
          {
            name: this.$t('header.newNav.ev'),
            link: process.env.VUE_APP_EV,
            target: '_self',
          },
          {
            name: this.$t('header.newNav.ipr'),
            link: process.env.VUE_APP_COPYRIGHT,
            target: '_self',
            currentNav: true
          },
          {
            name: this.$t('header.newNav.sign'),
            link: process.env.VUE_APP_SIGN,
            target: '_blank',
            nofollow: true
          },
          {
            name: this.$t('header.newNav.mail'),
            link: process.env.VUE_APP_EMAIL,
            target: '_self',
          },
          {
            name: this.$t('header.nav.aigc'),
            link: process.env.VUE_APP_AIGC,
            target: '_self',
          },
        ],
        samllNavBar: [
          {
            name: '知产鉴定',
            link: process.env.VUE_APP_CAPITAL + '/identification',
            target: '_blank',
            showLang: 'zh'
          },
          {
            name: '验证中心',
            link: process.env.VUE_APP_VERIFY,
            target: '_blank',
          },
        ],
      }
    },
    addressInfo() {
      return [
        {
          img: require("@/assets/images/newIndex/address1.png"),
          title: this.$t("display.sec1.title"),
          info: this.$t("display.sec1.info"),
        },
        {
          img: require("@/assets/images/newIndex/address2.png"),
          title: this.$t("display.sec2.title"),
          info: this.$t("display.sec2.info"),
        },
        {
          img: require("@/assets/images/newIndex/address3.png"),
          title: this.$t("display.sec3.title"),
          info: this.$t("display.sec3.info"),
        },
      ]
    },
    iprWorkInfo() {
      return {
        title: this.$t("iprWork.iprWorkInfo.title"),
        workLogo: require("@/assets/images/newIndex/workLogo.png"),
        listInfo: [
          {
            leftTitle: this.$t("iprWork.iprWorkInfo.listInfo.sec1.leftTitle"),
            leftInfo: this.$t("iprWork.iprWorkInfo.listInfo.sec1.leftInfo"),
            leftImg: require("@/assets/images/newIndex/workLeft1.png"),
            rightTitle: this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightTitle"),
            rightList1: {
              list: [
                this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList1.list1"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList1.list2"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList1.list3"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList1.list4"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList1.list5"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList1.list6"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList1.list7"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList1.list8"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList1.list9"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList1.list10"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList1.list11"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList1.list12"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList1.list13"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList1.list14"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList1.list15"),
              ],
              title: this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList1.title"),
            },
            rightList2: {
              list: [
                this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList2.list1"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList2.list2"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList2.list3"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList2.list4"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList2.list5"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList2.list6"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList2.list7"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList2.list8"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList2.list9"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList2.list10"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList2.list11"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList2.list12"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList2.list13"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList2.list14"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList2.list15"),
              ],
              title: this.$t("iprWork.iprWorkInfo.listInfo.sec1.rightList2.title"),
            },
            btnInfo: this.$t("iprWork.iprWorkInfo.listInfo.sec1.btnInfo"),
          },
          {
            leftTitle: this.$t("iprWork.iprWorkInfo.listInfo.sec2.leftTitle"),
            leftInfo: this.$t("iprWork.iprWorkInfo.listInfo.sec2.leftInfo"),
            leftImg: require("@/assets/images/newIndex/workLeft2.png"),
            rightTitle: this.$t("iprWork.iprWorkInfo.listInfo.sec2.rightTitle"),
            rightList1: {
              list: [
                this.$t("iprWork.iprWorkInfo.listInfo.sec2.rightList1.list1"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec2.rightList1.list2"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec2.rightList1.list3"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec2.rightList1.list4"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec2.rightList1.list5"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec2.rightList1.list6"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec2.rightList1.list7"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec2.rightList1.list8"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec2.rightList1.list9"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec2.rightList1.list10"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec2.rightList1.list11"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec2.rightList1.list12"),
              ],
              title: this.$t("iprWork.iprWorkInfo.listInfo.sec2.rightList1.title"),
            },
            btnInfo: this.$t("iprWork.iprWorkInfo.listInfo.sec2.btnInfo"),
          },
          {
            leftTitle: this.$t("iprWork.iprWorkInfo.listInfo.sec3.leftTitle"),
            leftInfo: this.$t("iprWork.iprWorkInfo.listInfo.sec3.leftInfo"),
            leftImg: require("@/assets/images/newIndex/workLeft3.png"),
            rightTitle: this.$t("iprWork.iprWorkInfo.listInfo.sec3.rightTitle"),
            rightTitle2: this.$t("iprWork.iprWorkInfo.listInfo.sec3.rightTitle2"),
            rightList1: {
              list: [
                this.$t("iprWork.iprWorkInfo.listInfo.sec3.rightList1.list1"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec3.rightList1.list2"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec3.rightList1.list3"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec3.rightList1.list4"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec3.rightList1.list5"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec3.rightList1.list6"),
              ],
              title: this.$t("iprWork.iprWorkInfo.listInfo.sec3.rightList1.title"),
            },
            rightList2: {
              list: [
                this.$t("iprWork.iprWorkInfo.listInfo.sec3.rightList2.list1"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec3.rightList2.list2"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec3.rightList2.list3"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec3.rightList2.list4"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec3.rightList2.list5"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec3.rightList2.list6"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec3.rightList2.list7"),
              ],
              title: this.$t("iprWork.iprWorkInfo.listInfo.sec3.rightList2.title"),
            },
            btnInfo: this.$t("iprWork.iprWorkInfo.listInfo.sec3.btnInfo"),
          },
          {
            leftTitle: this.$t("iprWork.iprWorkInfo.listInfo.sec4.leftTitle"),
            leftInfo: this.$t("iprWork.iprWorkInfo.listInfo.sec4.leftInfo"),
            leftImg: require("@/assets/images/newIndex/workLeft4.png"),
            rightTitle: this.$t("iprWork.iprWorkInfo.listInfo.sec4.rightTitle"),
            rightList1: {
              list: [
                this.$t("iprWork.iprWorkInfo.listInfo.sec4.rightList1.list1"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec4.rightList1.list2"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec4.rightList1.list3"),
                this.$t("iprWork.iprWorkInfo.listInfo.sec4.rightList1.list4"),
                // this.$t("iprWork.iprWorkInfo.listInfo.sec4.rightList1.list5"),
                // this.$t("iprWork.iprWorkInfo.listInfo.sec4.rightList1.list6"),
                // this.$t("iprWork.iprWorkInfo.listInfo.sec4.rightList1.list8"),
                // this.$t("iprWork.iprWorkInfo.listInfo.sec4.rightList1.list9"),
                // this.$t("iprWork.iprWorkInfo.listInfo.sec4.rightList1.list10"),
              ],
              title: this.$t("iprWork.iprWorkInfo.listInfo.sec4.rightList1.title"),
            },
            btnInfo: this.$t("iprWork.iprWorkInfo.listInfo.sec4.btnInfo"),
          },
        ],
      }
    },
    solutionInfo() {
      return {
        leftIcon: require("@/assets/images/newIndex/leftIcon.png"),
        rightIcon: require("@/assets/images/newIndex/rightIcon.png"),
        solutionList: [
          {
            title: this.$t("solutionInfo.solutionList.sec1.title"),
            infoTitleList: [
              this.$t("solutionInfo.solutionList.sec1.infoTitleList.list1"),
              this.$t("solutionInfo.solutionList.sec1.infoTitleList.list2"),
              this.$t("solutionInfo.solutionList.sec1.infoTitleList.list3"),
              this.$t("solutionInfo.solutionList.sec1.infoTitleList.list4"),
              this.$t("solutionInfo.solutionList.sec1.infoTitleList.list5"),
            ],
            infoMain: this.$t("solutionInfo.solutionList.sec1.infoMain"),
            infoMain1: this.$t("solutionInfo.solutionList.sec1.infoMain1"),
            infoMain2: this.$t("solutionInfo.solutionList.sec1.infoMain2"),
            infoMain3: this.$t("solutionInfo.solutionList.sec1.infoMain3"),
            infoMain4: this.$t("solutionInfo.solutionList.sec1.infoMain4"),
            infoBtn: this.$t("solutionInfo.solutionList.sec1.infoBtn"),
            solutionIcon: require("@/assets/images/newIndex/solution1.png"),
          },
          {
            title: this.$t("solutionInfo.solutionList.sec2.title"),
            infoTitleList: [
              this.$t("solutionInfo.solutionList.sec2.infoTitleList.list1"),
              this.$t("solutionInfo.solutionList.sec2.infoTitleList.list2"),
              this.$t("solutionInfo.solutionList.sec2.infoTitleList.list3"),
              this.$t("solutionInfo.solutionList.sec2.infoTitleList.list4"),
              this.$t("solutionInfo.solutionList.sec2.infoTitleList.list5"),
              this.$t("solutionInfo.solutionList.sec2.infoTitleList.list6"),
              this.$t("solutionInfo.solutionList.sec2.infoTitleList.list7"),
            ],
            infoTitle: this.$t("solutionInfo.solutionList.sec2.infoTitle"),
            infoMain: this.$t("solutionInfo.solutionList.sec2.infoMain"),
            infoMain1: this.$t("solutionInfo.solutionList.sec2.infoMain1"),
            infoMain2: this.$t("solutionInfo.solutionList.sec2.infoMain2"),
            infoMain3: this.$t("solutionInfo.solutionList.sec2.infoMain3"),
            solutionIcon: require("@/assets/images/newIndex/solution2.png"),
          },
          {
            title: this.$t("solutionInfo.solutionList.sec3.title"),
            infoTitleList: [
              this.$t("solutionInfo.solutionList.sec3.infoTitleList.list1"),
              this.$t("solutionInfo.solutionList.sec3.infoTitleList.list2"),
              this.$t("solutionInfo.solutionList.sec3.infoTitleList.list3"),
              this.$t("solutionInfo.solutionList.sec3.infoTitleList.list4"),
            ],
            infoTitle: this.$t("solutionInfo.solutionList.sec3.infoTitle"),
            infoMain: this.$t("solutionInfo.solutionList.sec3.infoMain"),
            infoMain1: this.$t("solutionInfo.solutionList.sec3.infoMain1"),
            infoMain2: this.$t("solutionInfo.solutionList.sec3.infoMain2"),
            solutionIcon: require("@/assets/images/newIndex/solution3.png"),
          },
          {
            title: this.$t("solutionInfo.solutionList.sec4.title"),
            infoTitleList: [
              this.$t("solutionInfo.solutionList.sec4.infoTitleList.list1"),
              this.$t("solutionInfo.solutionList.sec4.infoTitleList.list2"),
              this.$t("solutionInfo.solutionList.sec4.infoTitleList.list3"),
              this.$t("solutionInfo.solutionList.sec4.infoTitleList.list4"),
              this.$t("solutionInfo.solutionList.sec4.infoTitleList.list5"),
              this.$t("solutionInfo.solutionList.sec4.infoTitleList.list6"),
            ],
            infoTitle: this.$t("solutionInfo.solutionList.sec4.infoTitle"),
            infoMain: this.$t("solutionInfo.solutionList.sec4.infoMain"),
            infoMain1: this.$t("solutionInfo.solutionList.sec4.infoMain1"),
            infoMain2: this.$t("solutionInfo.solutionList.sec4.infoMain2"),
            infoMain3: this.$t("solutionInfo.solutionList.sec4.infoMain3"),
            solutionIcon: require("@/assets/images/newIndex/solution4.png"),
          },
          {
            title: this.$t("solutionInfo.solutionList.sec5.title"),
            infoTitleList: [
              this.$t("solutionInfo.solutionList.sec5.infoTitleList.list1"),
              this.$t("solutionInfo.solutionList.sec5.infoTitleList.list2"),
              this.$t("solutionInfo.solutionList.sec5.infoTitleList.list3"),
              this.$t("solutionInfo.solutionList.sec5.infoTitleList.list4"),
              this.$t("solutionInfo.solutionList.sec5.infoTitleList.list5"),
              this.$t("solutionInfo.solutionList.sec5.infoTitleList.list6"),
              this.$t("solutionInfo.solutionList.sec5.infoTitleList.list7"),
            ],
            infoTitle: this.$t("solutionInfo.solutionList.sec5.infoTitle"),
            infoMain: this.$t("solutionInfo.solutionList.sec5.infoMain"),
            infoMain1: this.$t("solutionInfo.solutionList.sec5.infoMain1"),
            infoMain2: this.$t("solutionInfo.solutionList.sec5.infoMain2"),
            infoMain3: this.$t("solutionInfo.solutionList.sec5.infoMain3"),
            infoMain4: this.$t("solutionInfo.solutionList.sec5.infoMain4"),
            solutionIcon: require("@/assets/images/newIndex/solution5.png"),
          },
          {
            title: this.$t("solutionInfo.solutionList.sec6.title"),
            infoTitleList: [
              this.$t("solutionInfo.solutionList.sec6.infoTitleList.list1"),
              this.$t("solutionInfo.solutionList.sec6.infoTitleList.list2"),
              this.$t("solutionInfo.solutionList.sec6.infoTitleList.list3"),
              this.$t("solutionInfo.solutionList.sec6.infoTitleList.list4"),
            ],
            infoTitle: this.$t("solutionInfo.solutionList.sec6.infoTitle"),
            infoMain: this.$t("solutionInfo.solutionList.sec6.infoMain"),
            infoMain1: this.$t("solutionInfo.solutionList.sec6.infoMain1"),
            infoMain3: this.$t("solutionInfo.solutionList.sec6.infoMain3"),
            infoMain4: this.$t("solutionInfo.solutionList.sec6.infoMain4"),
            solutionIcon: require("@/assets/images/newIndex/solution6.png"),
          },
          {
            title: this.$t("solutionInfo.solutionList.sec7.title"),
            infoTitleList: [
              this.$t("solutionInfo.solutionList.sec7.infoTitleList.list1"),
              this.$t("solutionInfo.solutionList.sec7.infoTitleList.list2"),
              this.$t("solutionInfo.solutionList.sec7.infoTitleList.list3"),
            ],
            infoTitle: this.$t("solutionInfo.solutionList.sec7.infoTitle"),
            infoMain: this.$t("solutionInfo.solutionList.sec7.infoMain"),
            infoMain1: this.$t("solutionInfo.solutionList.sec7.infoMain1"),
            infoMain2: this.$t("solutionInfo.solutionList.sec7.infoMain2"),
            infoMain3: this.$t("solutionInfo.solutionList.sec7.infoMain3"),
            solutionIcon: require("@/assets/images/newIndex/solution7.png"),
          },
          {
            title: this.$t("solutionInfo.solutionList.sec8.title"),
            infoTitleList: [
              this.$t("solutionInfo.solutionList.sec8.infoTitleList.list1"),
              this.$t("solutionInfo.solutionList.sec8.infoTitleList.list2"),
              this.$t("solutionInfo.solutionList.sec8.infoTitleList.list3"),
              this.$t("solutionInfo.solutionList.sec8.infoTitleList.list4"),
              this.$t("solutionInfo.solutionList.sec8.infoTitleList.list5"),
              this.$t("solutionInfo.solutionList.sec8.infoTitleList.list6"),
              this.$t("solutionInfo.solutionList.sec8.infoTitleList.list7"),
            ],
            infoTitle: this.$t("solutionInfo.solutionList.sec8.infoTitle"),
            infoMain: this.$t("solutionInfo.solutionList.sec8.infoMain"),
            infoMain1: this.$t("solutionInfo.solutionList.sec8.infoMain1"),
            infoMain2: this.$t("solutionInfo.solutionList.sec8.infoMain2"),
            infoMain3: this.$t("solutionInfo.solutionList.sec8.infoMain3"),
            solutionIcon: require("@/assets/images/newIndex/solution8.png"),
          },
          {
            title: this.$t("solutionInfo.solutionList.sec9.title"),
            infoTitleList: [
              this.$t("solutionInfo.solutionList.sec9.infoTitleList.list1"),
              this.$t("solutionInfo.solutionList.sec9.infoTitleList.list2"),
              this.$t("solutionInfo.solutionList.sec9.infoTitleList.list3"),
              this.$t("solutionInfo.solutionList.sec9.infoTitleList.list4"),
              this.$t("solutionInfo.solutionList.sec9.infoTitleList.list5"),
              this.$t("solutionInfo.solutionList.sec9.infoTitleList.list6"),
              this.$t("solutionInfo.solutionList.sec9.infoTitleList.list7"),
              this.$t("solutionInfo.solutionList.sec9.infoTitleList.list8"),
            ],
            infoTitle: this.$t("solutionInfo.solutionList.sec9.infoTitle"),
            infoMain: this.$t("solutionInfo.solutionList.sec9.infoMain"),
            infoMain1: this.$t("solutionInfo.solutionList.sec9.infoMain1"),
            infoMain2: this.$t("solutionInfo.solutionList.sec9.infoMain2"),
            infoMain3: this.$t("solutionInfo.solutionList.sec9.infoMain3"),
            infoMain4: this.$t("solutionInfo.solutionList.sec9.infoMain4"),
            solutionIcon: require("@/assets/images/newIndex/solution9.png"),
          },
          {
            title: this.$t("solutionInfo.solutionList.sec10.title"),
            infoTitleList: [
              this.$t("solutionInfo.solutionList.sec10.infoTitleList.list1"),
              this.$t("solutionInfo.solutionList.sec10.infoTitleList.list2"),
              this.$t("solutionInfo.solutionList.sec10.infoTitleList.list3"),
              this.$t("solutionInfo.solutionList.sec10.infoTitleList.list4"),
              this.$t("solutionInfo.solutionList.sec10.infoTitleList.list5"),
            ],
            infoTitle: this.$t("solutionInfo.solutionList.sec10.infoTitle"),
            infoMain: this.$t("solutionInfo.solutionList.sec10.infoMain"),
            infoMain1: this.$t("solutionInfo.solutionList.sec10.infoMain1"),
            infoMain2: this.$t("solutionInfo.solutionList.sec10.infoMain2"),
            infoMain3: this.$t("solutionInfo.solutionList.sec10.infoMain3"),
            solutionIcon: require("@/assets/images/newIndex/solution10.png"),
          },
        ]
      }
    }
  },

  created() {
    this.getPrecedentList();
    this.getQuestionList();
    this.getprecedentStatistics();
    this.initWork();
    me().then((res) => {
      if (res) {
        this.userInfo = res;
      }
    }).catch(err => {
      this.userInfo = {}
    })
  },

  mounted() {
    let _this = this
    timer = setInterval(() => {
      if (_this.percentage < 100) {
        _this.percentage = _this.percentage + 2;
      }
    }, 200)
  },
  methods: {

    getTime() {
      getCurrentTime().then(res => {
        this.currentTime = res;
      });
    },
    onLogin() {
      this.$router.push({
        path: '/login',
        query: this.$route.query,
      })
    },
    onLogout() {
      localStorage.removeItem('queryData')
      localStorage.removeItem('popups');
      if (process.env.NODE_ENV === 'development') {
        window.location.href = '/api/api/logout'
      } else {
        window.location.href = '/api/logout'
      }
    },
    tab(n) {
      this.active = n;
    },
    async getprecedentStatistics() {
      let res = await precedentStatistics();
      if (res) {
        this.accountNum = res;
      }
    },
    getPrecedentList() {
      let that = this;
      precedentSearchByCondition({
        size: 3,
        usageDictionaryIds: 1001549,
        page: 1,
        sort: 1,
      })
          .then((res) => {
            that.conditionList = res.data;
          })
          .catch((err) => {
          });
    },
    getQuestionList() {
      let that = this;
      questionAnswer({
        size: 5,
        sourceType: 952310,
        page: 1,
        sort: 1,
      })
          .then((res) => {
            that.questionsList = res.data;
          })
          .catch((err) => {
          });
    },
    tabCourt(data) {
      let httpUrl =
          data.id === 1001549 ? precedentSearchByCondition :
              data.id === 1001548 ? precedentSearchByCondition :
                  precedent
      let paramsObj =
          data.id === 1001549 ? {usageDictionaryIds: 1001549} :
              data.id === 1001548 ? {usageDictionaryIds: 1001548} :
                  {dictionaryId: data.id}
      paramsObj.size = 3
      paramsObj.sort = 1
      paramsObj.page = 1
      this.tabactive = data.id;
      let that = this;
      httpUrl(
          paramsObj)
          .then((res) => {
            that.conditionList = res.data;
          })
          .catch((err) => {
          });
    },
    goTsa(path, id) {
      if (id) {
        let newID = TsaConvertId(id, path);
        window.open(process.env.VUE_APP_TSA + '/' + path + '/' + newID + '.html')
      } else {
        window.open(process.env.VUE_APP_TSA + '/' + path + '.html')
      }
    },
    onSearch() {
      window.open(
          process.env.VUE_APP_TSA + "/" + `wiki.html?swd=${encodeURIComponent(this.keywords)}`
      );
    },
    // 新版首页
    workClick(item, index) {
      if (this.workActive !== index) {
        this.percentage = 0;
        this.workActive = index;
      }
    },
    solutionClick(item, index) {
      this.solutionActive = index;
    },

    prevBtn() {
      this.$refs.solutionSwiper.swiper.slidePrev();
    },
    nextBtn() {
      this.$refs.solutionSwiper.swiper.slideNext();
    },
    initWork() {
      this.workActive = 0;
    },
    addressClick(index) {
      let url =
          index === 0 ? 'https://www.tsa.cn/news/detail/4235' :
              index === 1 ? 'https://www.tsa.cn/news/detail/4122' :
                  index === 2 ? 'https://www.tsa.cn/honor' : ''
      hrefOpen(url)
    },
    mouseOver(data) {
      clearInterval(timer);
    },
    mouseLeave(data) {
      timer = setInterval(() => {
        if (this.percentage < 100) {
          this.percentage = this.percentage + 2;
        }
      }, 200);
    }
  },
};
</script>
<style src="../../../assets/css/home.less" lang="less" scoped></style>
<style lang="less" scoped>
.wrap {
  //padding-top: 80px;

  .baseBreak {
    -webkit-line-clamp: 1;
    -moz-line-clamp: 1;
    -ms-line-clamp: 1;
    -o-line-clamp: 1;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}

p {
  margin: 0;
}

.headerNav {
  position: fixed;
  top: 0;
  z-index: 999;
  width: 100%;
}

.zhe {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;

  .contentImage {
    position: relative;

    .temClose {
      display: block;
      width: 48px;
      height: 48px;
      margin: 20px auto 0;
    }

    .close {
      position: absolute;
      top: -30px;
      right: -30px;

      i {
        cursor: pointer;
        color: #fff;
        font-size: 30px;
      }
    }

    img {
      width: 100%;
      cursor: pointer;
    }
  }
}
</style>
<style>
.precedents .el-input__icon {
  line-height: 35px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

.swiper-container {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  z-index: 1;
}
</style>
